module.exports = __webpack_public_path__ + "img/bj_iyindao.07509ab6.png";